import React, { useEffect, useState } from 'react';

type Theme = 'light' | 'dark' | 'navy';

const THEME_ORDER: Theme[] = ['light', 'dark', 'navy'];
const THEME_LABEL: Record<Theme, string> = { light: '☀️ Light', dark: '🌙 Dark', navy: '🌊 Navy' };
const STORAGE_KEY = 'oss-theme';

const getInitialTheme = (): Theme => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'navy') return saved;
  } catch {
    // localStorage unavailable — fall through to default.
  }
  return 'dark'; // matches the site's original look, so nothing changes for anyone who hasn't chosen yet
};

const ThemeToggle = ({ mobile = false }: { mobile?: boolean }) => {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Not critical if this fails — theme just won't persist across visits.
    }
  }, [theme]);

  const cycleTheme = () => {
    const nextIndex = (THEME_ORDER.indexOf(theme) + 1) % THEME_ORDER.length;
    setTheme(THEME_ORDER[nextIndex]);
  };

  return (
    <button
      onClick={cycleTheme}
      aria-label="Change color theme"
      style={{
        background: 'transparent',
        border: '1px solid rgba(201,168,76,0.3)',
        color: 'var(--gold)',
        padding: mobile ? '10px 16px' : '6px 12px',
        borderRadius: '50px',
        fontSize: mobile ? '14px' : '12px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      {THEME_LABEL[theme]}
    </button>
  );
};

export default ThemeToggle;
